import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseShortLink } from "./UseShortLink";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddShortLink(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [usage, setUsage] = useState();
  const { validate, addShortLink } = UseShortLink();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    title: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    link: false,
  });

  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/shortlink" },
          { name: "افزودن لینک کوتاه", url: "/shortlink/addShortLink" },
        ],
      }}
    >
      {!usage ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              sx={{ width: "100%" }}
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              fullWidth
              error={errorState.link}
              value={state.link ? state.link : ""}
              label="لینک "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, link: evt.target.value });
              }}
              sx={{
                textarea: { direction: "rtl" },
              }}
              multiline
              maxRows={4}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addShortLink(state, () => {
                    navigate("/shortlink", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/shortlink", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
